import { ErrorMessage, useField } from "formik";
import React from "react";

import QuestionCopy from "./QuestionCopy";
import QuestionWrapper from "./QuestionWrapper";

type TQuestionTextareaProps = {
  name: string;
  label?: string;
  note?: string;
  characterCount?: number;
  error?: boolean;
};

const QuestionTextarea: React.FC<TQuestionTextareaProps> = ({ name, label, note, characterCount, error }) => {
  const [field] = useField(name);

  function getFieldLength() {
    if (field?.value?.length !== undefined) {
      return field?.value?.length;
    } else return 0;
  }

  return (
    <QuestionWrapper flex>
      <QuestionCopy name={name} label={label} note={note} />
      <textarea
        style={{
          width: "100%",
          maxWidth: "552px",
          height: "248px",
          borderRadius: "3px",
          backgroundColor: "white",
          color: "#222221CC",
          fontSize: "16px",
          paddingLeft: "1rem",
          border: "1px solid #BDB49F",
          appearance: "none",
          position: "relative",
          resize: "none",
          outline: error ? "1px solid" : undefined,
          outlineColor: error ? "#D82727" : undefined,
        }}
        {...field}
      />
      {characterCount && (
        <div
          style={{
            display: "flex",
            width: "100%",
            fontSize: "16px",
            color: "#222221CC",
            maxWidth: "551px",
            textAlign: "right",
            justifyContent: "right",
          }}
        >
          {characterCount - getFieldLength()} characters remaining
        </div>
      )}
      <ErrorMessage name={name}>
        {(msg) => <p style={{ fontSize: "14px", color: "#D82727" }}>{msg}</p>}
      </ErrorMessage>
    </QuestionWrapper>
  );
};

export default QuestionTextarea;
